/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { ThemeOptions } from '@mui/material/styles';

export const contrastText: ThemeOptions = {
	contrastText: {
		primary: {
			light: '#333333',
			main: '#ffffff',
			dark: '#ffffff',
		},
		secondary: {
			main: '#333333',
			light: '#ffffff',
			dark: '#ffffff',
		},
		grey: {
			'50': '#333333',
			'100': '#333333',
			'200': '#ffffff',
			'300': '#ffffff',
			'400': '#ffffff',
			'500': '#ffffff',
		},
		success: {
			light: '#333333',
			main: '#ffffff',
			dark: '#ffffff',
		},
		warning: {
			light: '#333333',
			main: '#ffffff',
			dark: '#ffffff',
		},
		error: {
			light: '#333333',
			main: '#ffffff',
			dark: '#ffffff',
		},
	},
} as ThemeOptions;
